import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {breakpoints, CustomPropShapes} from '../../constants';
import ScrollManager from './ScrollManager';

export const propTypes = {
    breakpoint: CustomPropShapes.oneOfConstant(breakpoints.name),
    forwardedRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({current: PropTypes.elementType})
    ])
};

export const DEFAULT_SCROLL_PROPS = {
    scrollX: 0,
    scrollY: 0
};

const WithScroll = WrappedComponent => {
    class WithScrollClass extends PureComponent {
        static propTypes = {
            ...propTypes
        };
        state = this.getInitialSizeProps();

        componentDidMount() {
            this.key = ScrollManager.subscribe(this.onScroll);
        }

        componentWillUnmount() {
            ScrollManager.unsubscribe(this.key);
        }

        getInitialSizeProps() {
            const ScrollManagerProps = ScrollManager.getProps();

            if (ScrollManagerProps) {
                return ScrollManagerProps;
            }

            return DEFAULT_SCROLL_PROPS;
        }

        onScroll = ({scrollX, scrollY}) => {
            this.setState({
                scrollX,
                scrollY
            });
        };

        render() {
            const {forwardedRef} = this.props;
            const {scrollX, scrollY} = this.state;

            return (
                <WrappedComponent
                    windowScrollX={scrollX}
                    ref={forwardedRef}
                    windowScrollY={scrollY}
                    {...this.props}
                />
            );
        }
    }

    WithScroll.displayName = `WithScroll(${getDisplayName(WrappedComponent)})`;

    return React.forwardRef((props, ref) => {
        return <WithScrollClass {...props} forwardedRef={ref} />;
    });
};

function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default WithScroll;
